// https://github.com/uidotdev/usehooks
import { useCallback, useState } from "react";

export function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      if (item && item !== 'undefined') {
        try {
          return JSON.parse(item);
        } catch (error) {
          console.log("JSON parsing error:", error, typeof item, item);
          return initialValue;
        }
      } else {
        return initialValue;
      }
    } catch (error) {
      // If error also return initialValue
      if (initialValue !== undefined) {
        console.log(error);
      }
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      if (value !== undefined) {
        console.log(error);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return [storedValue, useCallback(setValue, [key, initialValue])];
}